import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
    if (!dateString) return 'N/A';
    try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    } catch {
        return 'N/A';
    }
}

export function formatStatus(status) {
    if (!status) return 'Unknown';
    return status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
}

export function getStatusClass(status) {
    if (!status) return 'status-unknown';
    const s = status.toLowerCase();
    if (s === 'delivered') return 'status-delivered';
    if (s.includes('transit')) return 'status-transit';
    if (s === 'pre_transit') return 'status-pre_transit';
    if (s === 'failure' || s === 'returned') return 'status-failure';
    return 'status-unknown';
}

export function getDirectionClass(direction) {
    return direction === 'inbound' ? 'direction-inbound' : 'direction-outbound';
}
